export enum LogLevel {
  error,
  warn,
  log,
  debug,
}
